module.exports = __webpack_public_path__ + "static/image/service/pc/gift.jpg?d59c7b92";